// extracted by mini-css-extract-plugin
export default {"tabsList":"qMrekbXka1M_ZkdBCowm","tabContent":"HbYklpML7q8Gtb1K7DwS","dialogContent":"EqdUFj8eYf0kHFJq28f2","tabsRoot":"VJuJvbwuIwVWOWhQFGPQ","tabContentBox":"ichypBeCq9UM6Ije3yqI"};